import {listener} from "../../../../modules/vegas/js/util";
import axios from "axios";

listener('submit', '#form-auth-phone', (form, e) => {
	let phoneElement = form.querySelector('[name=phone]');
	let phone = phoneElement.value;
	let btn = form.querySelector('button[type=submit]');

	btn.disabled = true;

	let msgError = form.querySelector('.msg-error');

	phoneElement.classList.remove('is-invalid');

	axios.post(form.action, new FormData(form))
		.then((response) => {
			phoneElement.classList.toggle('is-invalid', response.data.error);
			msgError.innerText = response.data.msg || '';
			msgError.classList.toggle('d-none', !response.data.error);
			btn.disabled = false;

			if (!response.data.error) {
				form.classList.add('d-none');

				let formCode = document.getElementById('form-auth-phone-code');
				formCode.classList.remove('d-none');
				formCode.querySelector('[name="phone"]').value = phone;
			}
		});
}, true);

listener('submit', '#form-auth-phone-code', (form, e) => {
	let btn = form.querySelector('button[type=submit]');
	btn.disabled = true;

	let msgError = form.querySelector('.msg-error');

	axios.post(form.action, new FormData(form))
		.then((response) => {
			btn.disabled = false;

			msgError.innerText = response.data.msg || '';
			msgError.classList.toggle('d-none', !response.data.error);

			if (!response.data.error && response.data.redirect_to) {
				location.href = response.data.redirect_to;
			}
		});
}, true);
